// Leggero feedback aptico su mobile (Vibration API). No-op dove non supportato.
export const vibrate = (pattern = 10) => {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(pattern);
    }
  } catch {
    /* ignore */
  }
};

// Preset comodi
export const hapticLight = () => vibrate(10);
export const hapticMedium = () => vibrate(18);
export const hapticStrong = () => vibrate([15, 30, 15]);
